import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {HttpClient } from '@angular/common/http';
import { baseURL , VERSION } from '../../app/constant/constant';

@Injectable({
  providedIn: 'root'
})
export class RolesStudyService {
  constructor(private http : HttpClient) { }

  getRolesStudy():Observable<any>{
    return this.http.get(`${baseURL}users/${VERSION}/platform-roles`);
  }
  
}
